function decode(text) {
  return text
}


export default function decodeQuestions(array) {
  return array.map((item) => ({ ...item, question: decode(item.question)}))
}



// WEBPACK FOOTER //
// ./src/state/utils/decodeQuestions.js